// components/ModalDecorations.jsx
const ModalDecorations = ({ type = "login" }) => {
    const decorationsConfig = {
        login: {
            blueBall: "tw-left-[15%] tw-top-[-10%]",
            yellowCircle: "tw-bottom-[-7%] tw-right-[4%] tw-left-auto tw-top-auto",
            purpleEmpty: "tw-left-[20%] tw-bottom-[-5%]",
            purplePlus: "tw-right-[15%] tw-top-[-25%]",
            purpleEmpty2: "tw-left-[62%] tw-bottom-[36%]",
        },
        loginInAs: {
            blueBall: "tw-left-[10%] tw-top-[20%]",
            yellowCircle: "tw-hidden",
            purpleEmpty: "tw-left-[3%] tw-bottom-[6%]",
            purplePlus: "tw-right-[15%] tw-top-[30%]",
            purpleEmpty2: "tw-hidden",
        },
        fullWidth: {
            rightFoot: "tw-w-[12%] tw-top-[5%] tw-left-[44%]",
            purplePlusRight: "tw-top-[10%] tw-right-[15%]",
            purpleEmptyRight: "tw-top-[10%] tw-right-[20%]",
            purplePlusCenter: "tw-bottom-[40%] tw-right-[45%]",
            purpleEmptyCenter: "tw-bottom-[35%] tw-right-[40%]",
        },
        // case mới cho modal offer
        offer: {
            // có thể config thêm nếu muốn position động
        },
    };
    const classes = decorationsConfig[type] || decorationsConfig.default;

    if (type === "fullWidth") {
        return (
            <div className="tw-hidden sm:tw-block">
                <img
                    src="/assets/images/right-footimg-opt.png"
                    className={`tw-absolute ${classes.rightFoot}`}
                    alt="right-foot"
                />
                <img
                    className={`tw-absolute ${classes.purplePlusRight}`}
                    src="/assets/images/purple_plus.png"
                    alt="plus-right"
                    width={16}
                />
                <img
                    className={`tw-absolute ${classes.purpleEmptyRight}`}
                    src="/assets/images/purple_empty_circle.png"
                    alt="empty-right"
                    width={24}
                />
                <img
                    className={`tw-absolute ${classes.purplePlusCenter}`}
                    src="/assets/images/purple_plus.png"
                    alt="plus-center"
                    width={16}
                />
                <img
                    className={`tw-absolute ${classes.purpleEmptyCenter}`}
                    src="/assets/images/purple_empty_circle.png"
                    alt="empty-center"
                    width={16}
                />
            </div>
        );
    }

    if (type === "offer") {
        return (
            <div className="tw-show-desktop edit-campaign">
                <img
                    className="blue-ball-popup"
                    src="/assets/images/blue_ball.png"
                    alt="blue-ball"
                    width={25}
                />
                <img
                    className="popup-yellow-circle"
                    src="/assets/images/yellow_circle.png"
                    alt="circle_3"
                    width={16}
                />
                <img
                    className="purple-empty-circle-popup"
                    src="/assets/images/purple_empty_circle.png"
                    alt="empty_circle"
                    width={20}
                />
                <img
                    className="purple-plus-popup"
                    src="/assets/images/purple_plus.png"
                    alt="plus"
                    width={16}
                />
                <img
                    className="purple-empty-circle-2-popup position-absolute"
                    src="/assets/images/purple_empty_circle.png"
                    alt="empty_circle_2"
                    width={16}
                />
            </div>
        );
    }

    return (
        <>
            <div className="tw-hidden sm:tw-block">
                <img
                    className={`blue-ball-brand-popup tw-absolute ${classes.blueBall}`}
                    src="/assets/images/blue_ball.png"
                    alt="blue-ball"
                    width={30}
                />
                <img
                    className={`popup-yellow-brand-circle tw-absolute ${classes.yellowCircle} tw-animate-none`}
                    src="/assets/images/yellow_circle.png"
                    alt="circle"
                    width={16}
                />
                <img
                    className={`purple-empty-circle-brand-popup tw-absolute ${classes.purpleEmpty}`}
                    src="/assets/images/purple_empty_circle.png"
                    alt="empty_circle"
                    width={20}
                />
                <img
                    className={`purple-plus-brand-popup tw-absolute ${classes.purplePlus}`}
                    src="/assets/images/purple_plus.png"
                    alt="plus"
                    width={16}
                />
                <img
                    className={`purple-empty-circle-2-brand-popup tw-absolute ${classes.purpleEmpty2}`}
                    src="/assets/images/purple_empty_circle.png"
                    alt="empty_circle_2"
                    width={16}
                />
            </div>
        </>
    );
};

export default ModalDecorations;
